module.exports = __webpack_public_path__ + "static/img/zzrz01.238ca38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzrz01.jpg
// module id = Cdo9
// module chunks = 1